import React, { useEffect } from 'react'
import RegisterForm from '../components/Register/RegisterForm'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const Register = () => {

  const userLogin = useSelector(state => state.userLogin)
  const { userDetails } = userLogin

  const navigate = useNavigate();

  useEffect(() => {
    if (userDetails.status === "ok") {
      navigate('/app/dashboard')
    }
  })

  return (
    <div className="p-4 md:p-8 lg:p-16 flex flex-col items-center">
      <RegisterForm />
    </div>
  )
}

export default Register